module.exports = __webpack_public_path__ + "img/snowboard.dfa1ec55.jpg";